<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">
        Movie Rate Card - ({{ movieDetail ? movieDetail.movie_title : "" }})
      </div>
    </div>
    <div class="page-container">
      <div class="row p-4">
        <div
          class="fv_ratecard mb-4 movie-version-box p-4"
          v-for="(cinema, cinemaIndex) in MainRateCardArray"
          :key="cinemaIndex"
        >
          <div class="">
            <div class="mb-3 row">
              <div class="col-10 row">
                <div class="col-4">
                  <div class="d-flex align-items-center">
                    <div class="dropdown-curve-container">
                      <label :class="cinema.selected_cinema ? 'shift-up' : ''">
                        {{ "Cinema" }}
                      </label>
                      <multiselect
                        :options="CinemaList"
                        :disabled="cinema.isBlocked"
                        label="cine_name"
                        track-by="cine_id"
                        v-model="cinema.selected_cinema"
                        @select="onSelectCinema($event, cinemaIndex)"
                        placeholder=""
                      ></multiselect>
                    </div>
                  </div>
                </div>
                <div class="col-4 align-self-center">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <div class="add-datepicker">
                        <Datepicker
                          :monday-first="true"
                          ref="programaticOpen"
                          v-model="cinema.from_date"
                          name="fdate1"
                          id="fdate1"
                          typeable
                          v-validate=""
                          class="bg-white-input"
                        ></Datepicker>
                        <label
                          class="bg-transparent"
                          :class="cinema.from_date ? 'active' : ''"
                          >From</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4 align-self-center">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <div class="add-datepicker">
                        <Datepicker
                          :monday-first="true"
                          ref="programaticOpen"
                          v-model="cinema.to_date"
                          name="fdate1"
                          id="fdate1"
                          typeable
                          v-validate=""
                          class="bg-white-input"
                        ></Datepicker>
                        <label
                          class="bg-transparent"
                          :class="cinema.to_date ? 'active' : ''"
                          >To</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2 align-self-center">
                <button
                  class="btn-transparent float-right"
                  @click="onAddCinemaPlus()"
                  v-if="cinemaIndex == 0"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="25"
                    width="25"
                  />
                </button>

                <button class="btn-transparent float-right" style="">
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="25"
                    width="25"
                    @click="onRemoveCinema(cinemaIndex)"
                  />
                </button>
              </div>
            </div>
            <div
              class="
                justify-content-center
                align-items-center
                movie-version-inner
              "
              v-for="(screenObj, screenIndex) in cinema.screenArray"
              :key="screenIndex"
              :class="screenIndex > 0 ? 'mt-3' : ''"
            >
              <div class="row pr-2">
                <div class="col-10">
                  <div class="row">
                    <div class="col-md-6 col-lg-4 mb-3">
                      <div class>
                        <h5 class="font-weight-bold">
                          {{ $t("Screens") }}
                        </h5>
                      </div>
                      <div class>
                        <div class="d-flex align-items-center">
                          <div class="dropdown-curve-container">
                            <label
                              :class="
                                screenObj.selected_screen ? 'shift-up' : ''
                              "
                            >
                              {{ "Screen" }}
                            </label>
                            <multiselect
                              :options="ScreenList(cinemaIndex)"
                              :disabled="screenObj.isBlocked"
                              :searchable="true"
                              label="screen_name"
                              track-by="screen_id"
                              v-model="screenObj.selected_screen"
                              @select="
                                onSelectScreen($event, cinemaIndex, screenIndex)
                              "
                              placeholder=""
                            ></multiselect>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <button
                    class="btn-transparent float-right"
                    @click="onAddScreenPlus(cinemaIndex)"
                    v-if="screenIndex == 0"
                    style=""
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="25"
                      width="25"
                    />
                  </button>

                  <button class="btn-transparent float-right" style="">
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="25"
                      width="25"
                      @click="onRemoveScreen(cinemaIndex, screenIndex)"
                    />
                  </button>
                </div>
              </div>
              <div
                class="
                  col-12
                  mb-2
                  movie-version-inner
                  justify-content-center
                  align-items-center
                "
                v-for="(
                  singleRatecard, singleRatecardIndex
                ) in screenObj.RateCardsArray"
                :key="singleRatecardIndex"
              >
                <div class="row mx-0 rounded-10">
                  <div class="col-12 mb-1 pl-3">
                    <h6 class="font-weight-bold">
                      {{ singleRatecard.sst_seat_type | uppercase }}
                    </h6>
                  </div>
                  <div class="col-lg-6 col-xl-2 mb-1 pl-0">
                    <div class="input-material">
                      <div
                        class="add-datepicker add-datepicker__cursor_disabled"
                      >
                        <vue-timepicker
                          manual-input
                          disabled
                          v-model="singleRatecard.start_date_time"
                          id="starttime"
                        ></vue-timepicker>
                        <label
                          class="bg-transparent"
                          :class="
                            singleRatecard.start_date_time ? 'active' : ''
                          "
                          >{{ $t("starttime") }}</label
                        >
                      </div>
                    </div>
                    <p class="error_message">
                      <span
                        v-if="submitted && !singleRatecard.start_date_time"
                        >{{ $t("rc_start_time_required") }}</span
                      >
                    </p>
                  </div>

                  <div class="col-lg-6 col-xl-2 mb-1 pl-4">
                    <div class="input-material">
                      <div
                        class="add-datepicker add-datepicker__cursor_disabled"
                      >
                        <vue-timepicker
                          manual-input
                          disabled
                          v-model="singleRatecard.end_date_time"
                          id="endtime"
                        ></vue-timepicker>
                        <label
                          class="bg-transparent"
                          :class="singleRatecard.end_date_time ? 'active' : ''"
                          >{{ $t("endtime") }}</label
                        >
                      </div>
                    </div>
                    <p class="error_message">
                      <span v-if="submitted && !singleRatecard.end_date_time">{{
                        $t("rc_end_time_required")
                      }}</span>
                    </p>
                  </div>

                  <div class="col-lg-6 col-xl-4 mb-1 pl-5">
                    <div class="d-flex align-items-center">
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            singleRatecard.selected_rate_card ? 'shift-up' : ''
                          "
                        >
                          {{ "Rate Card" }}
                        </label>
                        <multiselect
                          :options="cinema.RateCardsList"
                          label="rc_g_name"
                          track-by="rc_g_id"
                          v-model="singleRatecard.selected_rate_card"
                          @select="
                            onSelectRateCard(
                              $event,
                              cinemaIndex,
                              screenIndex,
                              singleRatecardIndex
                            )
                          "
                          placeholder=""
                        ></multiselect>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 col-xl-4 mb-1 ">
                    <div class="d-flex align-items-center">
                      <div class="dropdown-curve-container">
                        <label
                          :class="
                            singleRatecard.selected_private_rate_card
                              ? 'shift-up'
                              : ''
                          "
                        >
                          {{ "Private Rate Card" }}
                        </label>
                        <multiselect
                          :options="cinema.PrivateRateCardList"
                          label="rc_g_name"
                          track-by="rc_g_id"
                          v-model="singleRatecard.selected_private_rate_card"
                          @select="
                            onSelectPrivateRateCard(
                              $event,
                              cinemaIndex,
                              screenIndex,
                              singleRatecardIndex
                            )
                          "
                          placeholder=""
                        ></multiselect>
                      </div>
                    </div>
                  </div>

                  <div class="row ml-2">
                    
                    <div class="col-lg-12 col-xl-12">
                      <div class="row">
                        <div class="mr-1">{{ $t("show") }} {{ $t("days") }}:</div>
                        <b-form-checkbox
                          v-for="(
                            weekdaysLoop, weekdaysKey
                          ) in singleRatecard.weekDays"
                          :key="weekdaysKey"
                          style=""
                          class="j-checkbox mb-1 mx-1"
                          disabled
                          @change="
                            onChangeWeekdays(
                              $event,
                              weekdaysKey,
                              screenIndex,
                              singleRatecardIndex,
                              singleRatecard,
                              cinemaIndex
                            )
                          "
                          v-model="singleRatecard.weekDays[weekdaysKey]"
                        >
                          <div class="text-capitalize">
                            {{ weekdaysKey }}
                          </div>
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="false"
                    class="
                      col-1
                      d-flex
                      justify-content-center
                      align-items-center
                      border-left
                    "
                  >
                    <button
                      v-if="singleRatecardIndex === 0"
                      @click.prevent.stop="
                        increaseRateCard(cinemaIndex, screenIndex)
                      "
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="35"
                        width="35"
                      />
                    </button>

                    <button
                      v-else
                      @click.prevent.stop="
                        decreaseRatecardIndex(
                          cinemaIndex,
                          screenIndex,
                          singleRatecardIndex
                        )
                      "
                      class="btn-transparent"
                    >
                      <img
                        src="@/assets/img/icons/minus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 text-center mt-4">
        <button
          class="btn-blue"
          :disabled="disableBtn"
          @click.prevent.stop="handleSubmit(true)"
        >
          {{ $t("save") }}
        </button>
        <button
          class="btn-blue"
          v-if="is_reset_available"
          @click.prevent.stop="onClickReset()"
        >
          {{ $t("Remove") }}
        </button>
        <b-button
          class="btn-outline-grey"
          variant="default"
          to="/cinema-manager/movie-rate-card"
          >{{ $t("cancel") }}</b-button
        >
      </div>
    </div>
    <b-modal
      id="reset_override"
      title="Reset Movie Rate Card"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          Are you sure you want to remove Movie Rate Card?
        </p>
        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('reset_override')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="handleReset"
        >
          Remove
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import MyCinemaService from "@/services/MyCinemaService";
import scheduleService from "@/services/scheduleService";
import moment from "moment";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import DatePicker from "vue2-datepicker";

export default {
  components: { VueTimepicker, DatePicker },
  data() {
    return {
      md_id: null,
      cinemaErrorIndex: null,
      screenErrorIndex: null,
      is_reset_available: false,
      disableBtn: false,
      Cinemas: [],
      submitted: false,
      RemovedCinemas: [],
      FinalRateCardArray: [],
      movieDetail: "",
      from_date: "",
      to_date: "",
      MainRateCardArray: [
        {
          cinema_id: null,
          from_date: null,
          to_date: null,
          isBlocked: false,
          cinema_name: "",
          selected_cinema: "",
          screenList: [],
          RateCardsList: [],
          PrivateRateCardList: [],
          rc_cinema_is_active: "Y",
          RemovedScreens: [],
          screenArray: [
            {
              screen_id: null,
              isBlocked: false,
              screen_name: "",
              selected_screen: "",
              rc_screen_is_active: "Y",
              RateCardsArray: [
                {
                  rc_name: "Select Rate Card Group",
                  rcp_name: "Private Rate Card Group",
                  isBlocked: false,
                  selected_rate_card: "",
                  selected_private_rate_card: "",
                  start_date_time: "",
                  end_date_time: "",
                  rate_card_id: "",
                  rate_card_private_id: "",
                  rc_rate_card_group_is_active: "Y",
                  srcm_id: null,
                  unique_id: Math.round(Math.random() * 10000),
                  weekDays: {
                    selectAll: true,
                    sunday: true,
                    monday: true,
                    tuesday: true,
                    wednesday: true,
                    thursday: true,
                    friday: true,
                    saturday: true,
                  },
                },
              ],
            },
          ],
        },
      ],
    };
  },
  computed: {
    CinemaList() {
      let cinemaIds = this.MainRateCardArray.map((x) => x.cinema_id);
      let result = this.Cinemas.filter((x) => !cinemaIds.includes(x.cine_id));
      console.log("result CinemaList", result);
      return result;
    },
  },

  async beforeMount() {
    const { md_id } = this.$route.query;
    if (md_id) {
      this.md_id = md_id;
      this.getMovieDetail();
    } else {
      this.$router.go(-1);
    }
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.getCinemaList();
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj, 0);
    }
  },
  mounted() {},
  methods: {
    ScreenList(CinemaIndex) {
      let screenIds = this.MainRateCardArray[CinemaIndex].screenArray.map(
        (x) => x.screen_id
      );
      let result = this.MainRateCardArray[CinemaIndex].screenList.filter(
        (x) => !screenIds.includes(x.screen_id)
      );
      console.log("result ScreenList", result);
      return result;
    },
    getMovieRateCard(md_id) {
      let loader = this.$loading.show();
      MovieService.GetMovieRateCard({ md_id: md_id })
        .then(async (response) => {
          const { data } = response;
          console.log("DATA", data);
          console.log("response", response);
          if (data && data.status) {
            this.MainRateCardArray = data.MainRateCardArray;
            this.is_reset_available =
              data.Records && data.Records.length > 0 ? true : false;
            for (let i = 0; i < data.MainRateCardArray.length; i++) {
              console.log(
                "data.MainRateCardArray[i]",
                data.MainRateCardArray[i]
              );
              console.log("this.Cinemas", this.Cinemas);
              let cinema = this.Cinemas.find(
                (y) => y.cine_id == data.MainRateCardArray[i].cinema_id
              );
              console.log("cinema TEST FOR LOOP", cinema);
              if (cinema) {
                this.onSelectCinema(cinema, i);
              } else if (this.$store.getters.getSelectedDropDownCinema) {
                let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
                this.onSelectCinema(CinemaObj, i);
              }
            }
            // for (let x of data.MainRateCardArray) {
            //   let cinema = this.Cinemas.find(y => y.cine_id == x.cinema_id);
            //   console.log("cinema TEST FOR LOOP", cinema);
            //   await this.onSelectCinema(cinema, index);
            // }
            // data.MainRateCardArray.forEach(async (x, index) => {
            //   let cinema = this.Cinemas.find(y => y.cine_id == x.cinema_id);
            //   await this.onSelectCinema(cinema, index);
            // });
            console.log("data", data);
          } else {
            console.log("data", data.message);
          }
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    getMovieDetail() {
      let payload = {
        currentPage: 1,
        limit: 10,
        search: "",
        searchType: "All",
        md_id: this.md_id,
      };
      CinemasService.GetMovieDetailList(payload)
        .then((response) => {
          const { data } = response;
          console.log(data);
          if (data && data.status && data.Records.hasOwnProperty("data")) {
            if (data.Records.data.length > 0) {
              this.movieDetail = data.Records.data[0];
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema(cinema, cinemaIndex) {
      this.MainRateCardArray[cinemaIndex].cinema_id = cinema.cine_id;
      this.MainRateCardArray[cinemaIndex].cinema_name = cinema.cine_name;
      this.MainRateCardArray[cinemaIndex].selected_cinema = cinema;
      this.getAllActiveScreens(cinema.cine_id, cinemaIndex);
      this.getRatecardsList(cinema.cine_id, cinemaIndex);
    },
    onSelectScreen(screen, cinemaIndex, screenIndex) {
      this.MainRateCardArray[cinemaIndex].screenArray[screenIndex].screen_id =
        screen.screen_id;
      this.MainRateCardArray[cinemaIndex].screenArray[screenIndex].screen_name =
        screen.screen_name;
      this.MainRateCardArray[cinemaIndex].screenArray[
        screenIndex
      ].selected_screen = screen;
      this.getScreenRCList(screen.screen_id, cinemaIndex, screenIndex);
    },
    onSelectRateCard(rateCard, cinemaIndex, screenIndex, singleRatecardIndex) {
      this.MainRateCardArray[cinemaIndex].screenArray[
        screenIndex
      ].RateCardsArray[singleRatecardIndex].rc_name = rateCard.rc_g_name;
      this.MainRateCardArray[cinemaIndex].screenArray[
        screenIndex
      ].RateCardsArray[singleRatecardIndex].rate_card_id = rateCard.rc_g_id;
      this.MainRateCardArray[cinemaIndex].screenArray[
        screenIndex
      ].RateCardsArray[singleRatecardIndex].selected_rate_card = rateCard;
    },
    onSelectPrivateRateCard(
      rateCard,
      cinemaIndex,
      screenIndex,
      singleRatecardIndex
    ) {
      this.MainRateCardArray[cinemaIndex].screenArray[
        screenIndex
      ].RateCardsArray[singleRatecardIndex].rcp_name = rateCard.rc_g_name;
      this.MainRateCardArray[cinemaIndex].screenArray[
        screenIndex
      ].RateCardsArray[singleRatecardIndex].rate_card_private_id =
        rateCard.rc_g_id;
      this.MainRateCardArray[cinemaIndex].screenArray[
        screenIndex
      ].RateCardsArray[singleRatecardIndex].selected_private_rate_card =
        rateCard;
    },
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.getMovieRateCard(this.md_id);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    getAllActiveScreens: function (cinema_id, cinemaIndex) {
      this.MainRateCardArray[cinemaIndex].screenList = [];
      let payload = {
        cinema_id: cinema_id,
      };
      scheduleService
        .GetScreens(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.MainRateCardArray[cinemaIndex].screenList =
              data.Records.filter((x) => x.screen_seat_types.length > 0);
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(Error(error));
        });
    },
    getRatecardsList: function (cinema_id, cinemaIndex) {
      this.MainRateCardArray[cinemaIndex].RateCardsList = [];
      this.MainRateCardArray[cinemaIndex].PrivateRateCardList = [];
      scheduleService
        .GetPrivateRatecardGroupByCinemaId({ cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.MainRateCardArray[cinemaIndex].RateCardsList =
              data.Records.filter((x) => x.is_private_rate_card == "N");
            this.MainRateCardArray[cinemaIndex].PrivateRateCardList =
              data.Records.filter((x) => x.is_private_rate_card == "Y");
          } else {
            this.$toasted.show("No Rate Cards Found for selected cinema");
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getCinemaSetting :", error);
        });
    },
    onAddScreenPlus(cinemaIndex) {
      let obj = {
        screen_id: null,
        screen_name: "",
        isBlocked: false,
        selected_screen: "",
        rc_screen_is_active: "Y",
        movie_is_rate_active: "Y",
        RateCardsArray: [
          {
            rc_name: "Select Rate Card Group",
            rcp_name: "Private Rate Card Group",
            isBlocked: false,
            selected_rate_card: "",
            selected_private_rate_card: "",
            start_date_time: "",
            end_date_time: "",
            rate_card_id: "",
            rate_card_private_id: "",
            srcm_id: null,
            rc_rate_card_group_is_active: "Y",
            unique_id: Math.round(Math.random() * 10000),
            weekDays: {
              selectAll: true,
              sunday: true,
              monday: true,
              tuesday: true,
              wednesday: true,
              thursday: true,
              friday: true,
              saturday: true,
            },
          },
        ],
      };
      this.MainRateCardArray[cinemaIndex].screenArray.push(obj);
    },
    onRemoveScreen(cinemaIndex, screenIndex) {
      let screenObj =
        this.MainRateCardArray[cinemaIndex].screenArray[screenIndex];
      screenObj["movie_is_rate_active"] = "N";
      if (
        screenObj.hasOwnProperty("msrc_id") &&
        !this.MainRateCardArray[cinemaIndex].RemovedScreens.find(
          (x) => x.msrc_id == screenObj.msrc_id
        )
      ) {
        this.MainRateCardArray[cinemaIndex].RemovedScreens.push(screenObj);
      }
      this.MainRateCardArray[cinemaIndex].screenArray.splice(screenIndex, 1);
      if (this.MainRateCardArray[cinemaIndex].screenArray.length == 0) {
        this.onAddScreenPlus(cinemaIndex);
      }
    },
    increaseRateCard(cinemaIndex, screenIndex) {
      let obj = {
        rc_name: "Select Rate Card Group",
        rcp_name: "Private Rate Card Group",
        isBlocked: false,
        selected_rate_card: "",
        selected_private_rate_card: "",
        start_date_time: "",
        end_date_time: "",
        rate_card_id: "",
        rate_card_private_id: "",
        rc_rate_card_group_is_active: "Y",
        unique_id: Math.round(Math.random() * 10000),
        weekDays: {
          selectAll: true,
          sunday: true,
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
        },
      };
      this.MainRateCardArray[cinemaIndex].screenArray[
        screenIndex
      ].RateCardsArray.push(obj);
    },
    decreaseRatecardIndex(cinemaIndex, screenIndex, singleRatecardIndex) {
      this.MainRateCardArray[cinemaIndex].screenArray[
        screenIndex
      ].RateCardsArray.splice(singleRatecardIndex, 1);
    },
    onAddCinemaPlus() {
      let obj = {
        cinema_id: null,
        isBlocked: false,
        cinema_name: "",
        isBlocked: false,
        selected_cinema: "",
        rc_cinema_is_active: "Y",
        movie_is_rate_active: "Y",
        screenList: [],
        RateCardsList: [],
        PrivateRateCardList: [],
        RemovedScreens: [],
        screenArray: [
          {
            screen_id: null,
            screen_name: "",
            isBlocked: false,
            selected_screen: "",
            rc_screen_is_active: "Y",
            movie_is_rate_active: "Y",
            RateCardsArray: [
              {
                rc_name: "Select Rate Card Group",
                rcp_name: "Private Rate Card Group",
                selected_rate_card: "",
                isBlocked: false,
                selected_private_rate_card: "",
                start_date_time: "",
                end_date_time: "",
                rate_card_id: "",
                rate_card_private_id: "",
                srcm_id: null,
                rc_rate_card_group_is_active: "Y",
                unique_id: Math.round(Math.random() * 10000),
                weekDays: {
                  selectAll: true,
                  sunday: true,
                  monday: true,
                  tuesday: true,
                  wednesday: true,
                  thursday: true,
                  friday: true,
                  saturday: true,
                },
              },
            ],
          },
        ],
      };
      this.MainRateCardArray.push(obj);
    },
    onChangeWeekdays: function (
      event,
      keyname,
      screenIndex,
      singleRatecardIndex,
      singleRatecard,
      cinemaIndex
    ) {
      let unique_id = singleRatecard.unique_id;
      for (let seatType of this.MainRateCardArray[cinemaIndex].screenArray[
        screenIndex
      ].RateCardsArray) {
        let rateCard = seatType.rateCards.find(
          (x) => x.unique_id === unique_id
        );

        if (rateCard) {
          if (keyname !== "selectAll") {
            rateCard.weekDays["selectAll"] = false;
          }

          let len = Object.keys(rateCard.weekDays).length;
          if (keyname === "selectAll" && event) {
            rateCard.weekDays["selectAll"] = true;
            Object.keys(rateCard.weekDays).map((x) => {
              x !== "selectAll" ? (rateCard.weekDays[x] = true) : "";
            });
          } else if (keyname === "selectAll" && !event) {
            rateCard.weekDays["selectAll"] = false;
            Object.keys(rateCard.weekDays).map((x) => {
              x !== "selectAll" ? (rateCard.weekDays[x] = false) : "";
            });
          } else if (keyname !== "selectAll") {
            rateCard.weekDays[keyname] = event;

            if (rateCard.weekDays.selectAll) {
              rateCard.weekDays["selectAll"] = false;
            }
          }
        }
      }
    },
    onRemoveCinema(cinemaIndex) {
      let cinemaObj = this.MainRateCardArray[cinemaIndex];
      cinemaObj["movie_is_rate_active"] = "N";
      if (
        cinemaObj.hasOwnProperty("msrc_id") &&
        !this.RemovedCinemas.find((x) => x.msrc_id == cinemaObj.msrc_id)
      ) {
        this.RemovedCinemas.push(cinemaObj);
      }
      this.MainRateCardArray.splice(cinemaIndex, 1);
      if (this.MainRateCardArray.length == 0) {
        this.onAddCinemaPlus();
      }
    },
    mergeRemovedObj(MainRateCardArray) {
      let TempArr = [].concat(MainRateCardArray);
      if (TempArr.length > 0) {
        TempArr.forEach((x) => {
          x["screenArray"] = x["screenArray"].concat(x.RemovedScreens);
        });
        TempArr = TempArr.concat(this.RemovedCinemas);
      }
      return TempArr;
    },
    onClickReset() {
      this.$bvModal.show("reset_override");
    },
    handleReset() {
      this.MainRateCardArray.forEach((cinemaObj, cinemaObjIndex) => {
        cinemaObj["movie_is_rate_active"] = "N";
      });
      this.handleSubmit(true, false);
    },
    checkValidArray() {
      let count = 0;
      let errorMsg = "";
      this.MainRateCardArray.map((x, index) => {
        x.screenArray.map((y, s_index) => {
          if (!y.screen_id) {
            count++;
            errorMsg = "Please Select Screen";
            this.screenErrorIndex = s_index;
          }
        });

        if (!x.cinema_id) {
          count++;
          errorMsg = "Please Select Cinema";
          this.cinemaErrorIndex = index;
        } else if (!x.from_date) {
          count++;
          errorMsg = "Please Select From Date";
          this.cinemaErrorIndex = index;
        } else if (x.from_date && !x.to_date) {
          count++;
          errorMsg = "Please Select To Date";
          this.cinemaErrorIndex = index;
        } else if (moment(x.from_date).isAfter(x.to_date)) {
          count++;
          errorMsg = "From date must be greater than To date";
          this.cinemaErrorIndex = index;
        }
      });

      if (count > 0) {
        this.$toasted.show(errorMsg);
        return false;
      } else {
        return true;
      }
    },
    handleSubmit(redirect, checkValidation = true) {
      if (checkValidation && !this.checkValidArray()) {
        return;
      }
      this.FinalRateCardArray = this.mergeRemovedObj(this.MainRateCardArray);
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.disableBtn = true;
          let payload = {
            MainRateCardArray: this.FinalRateCardArray,
            md_id: this.md_id,
            from_date: moment(this.from_date).isValid()
              ? moment(this.from_date).format("YYYY-MM-DD")
              : null,
            to_date: moment(this.to_date).isValid()
              ? moment(this.to_date).format("YYYY-MM-DD")
              : null,
          };
          MovieService.AddMovieRateCard(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$router.push({
                  path: "/cinema-manager/movie-rate-card",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("Error:", err);
            })
            .finally(() => {
              this.disableBtn = false;
            });
        }
      });

      console.log("Final JSON", this.MainRateCardArray);
    },
    getScreenRCList: function (id, cinemaIndex, screenIndex) {
      let loader = this.$loading.show();
      let payload = {
        s_id: id,
      };
      MasterService.GetScreens(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              let RateCardArr = [];
              if (data.seattyperesult.length > 0) {
                data.seattyperesult.map((x) => {
                  x.rateCards.map((y) => {
                    let obj = {
                      ...y,
                      sst_seat_type: x.sst_seat_type,
                      selected_rate_card: this.MainRateCardArray[
                        cinemaIndex
                      ].RateCardsList.find((z) => z.rc_g_id == y.rate_card_id),
                      selected_private_rate_card: this.MainRateCardArray[
                        cinemaIndex
                      ].PrivateRateCardList.find(
                        (z) => z.rc_g_id == y.rate_card_private_id
                      ),
                    };
                    RateCardArr.push(obj);
                  });
                });
                this.MainRateCardArray[cinemaIndex].screenArray[
                  screenIndex
                ].RateCardsArray = RateCardArr;
                // this.normalizeScreenSeatDetails(
                //   data.seattyperesult,
                //   cinemaIndex,
                //   screenIndex
                // );
              }
            }
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    normalizeScreenSeatDetails: function (
      ScreenSeatDetail,
      cinemaIndex,
      screenIndex
    ) {
      let unique_start_end_times = [];

      for (let seatType of ScreenSeatDetail) {
        for (let rateCard of seatType.rateCards) {
          let isPresent = unique_start_end_times.find(
            (x) =>
              x.start_time === rateCard.start_date_time &&
              x.end_time === rateCard.end_date_time
          );

          if (!isPresent) {
            unique_start_end_times.push({
              start_time: rateCard.start_date_time,
              end_time: rateCard.end_date_time,
              unique_id: Math.round(Math.random() * 10000),
            });
          }
        }
      }

      for (let timing of unique_start_end_times) {
        for (let seatType of ScreenSeatDetail) {
          let rateCardIndex = seatType.rateCards.findIndex(
            (rateCard) =>
              timing.start_time === rateCard.start_date_time &&
              timing.end_time === rateCard.end_date_time
          );
          if (rateCardIndex === -1) {
            seatType.rateCards.push({
              rc_name: "Select Rate Card Group",
              rcp_name: "Rate Card Group Beta",
              start_date_time: timing.start_time,
              end_date_time: timing.end_time,
              rate_card_id: "",
              rate_card_private_id: "",
              unique_id: timing.unique_id,
              weekDays: {
                selectAll: true,
                sunday: true,
                monday: true,
                tuesday: true,
                wednesday: true,
                thursday: true,
                friday: true,
                saturday: true,
              },
            });
          } else {
            seatType.rateCards[rateCardIndex].unique_id = timing.unique_id;
          }
        }
      }

      this.MainRateCardArray[cinemaIndex].screenArray[
        screenIndex
      ].RateCardsArray = ScreenSeatDetail;
    },
  },
};
</script>
<style>
.add-datepicker.add-datepicker__cursor_disabled input {
  background: white !important;
  cursor: not-allowed;
}

.bg-white-input input {
  background: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MovieRateCard/editMovieRateCard.vue